<div class="trade-stack" data-element="trade-stack">

  <!-- Member cards: ONE card component serves every member — each individually previewable;
       the card owns its toggle + quote-driven live price, this stack only bubbles.
       Verbatim skill order (courier §6). NO aggregate set price anywhere (§10). -->
  <ets-opg-trade-card
      *ngFor="let member of this.members; trackBy: this.trackByMemberId"
      [suggestion]="member"
      [root]="this.root"
      [loadedPriceOf]="this.loadedPriceOf"
      (previewToggled)="this.onMemberPreviewToggled($event)"></ets-opg-trade-card>

  <!-- Three-dot separator: splits the Load-All bar from the individual member cards above it
       (mirrors the Hedging Grid Co-Pilot's aggregate-card separator, owner sketch). -->
  <div class="load-all-separator" *ngIf="this.hasMembers && this.showLoadAll" aria-hidden="true">
    <span></span><span></span><span></span>
  </div>

  <!-- Footer Load-All bar (sketch frame 04) — the convenience path, not the only path (A1).
       Flips to Un-Preview All once every member is previewed. Hidden whole under a
       'pick'-model host (showLoadAll=false). -->
  <div class="load-all-bar" *ngIf="this.hasMembers && this.showLoadAll">
    <dx-button data-element="btn-load-all"
               [text]="this.loadAllLabel"
               [type]="this.isFullyPreviewed ? 'normal' : 'default'"
               [disabled]="this.isLoadAllBlocked"
               (onClick)="this.onLoadAllClicked()"
               width="100%"></dx-button>
    <!-- WI-7: mixed-expiration remaining set -> reason (why you must enumerate). The action hint
         that used to sit here ("loads every not-yet-previewed trade at once") was REPLACED by the
         disclaimer in M8 — owner: "it does not carry any meaningful stuff". The REASON survives:
         unlike the hint it explains a DISABLED button, which the user otherwise cannot account for. -->
    <span class="reason" *ngIf="this.isLoadAllBlocked" data-element="load-all-reason">{{ this.loadAllDisabledReason }}</span>
    <!-- M8: UNCONDITIONAL w.r.t. the blocked state by design. The hint it replaced was gated on
         !isLoadAllBlocked; a compliance line must not vanish when the button is disabled, so this
         line carries no STATE-dependent gate. The *ngIf below is ONLY the global disclaimer switch
         (CR-20260723-003: client-requested disable) - when the feature is enabled this line is
         unconditional exactly as before. -->
    <span class="disclaimer" data-element="load-all-disclaimer" *ngIf="this.disclaimerEnabled"><span class="disclaimer-label">{{ this.disclaimer.label }}</span>: {{ this.disclaimer.text }}</span>
  </div>

</div>
